module.exports = __webpack_public_path__ + "static/media/article2-image.cf394552.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/article2-image.png
// module id = 359
// module chunks = 3